import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { SortType } from '../../models/sortType.model';
import { ChecklistItem } from '../../models/checklist-item.model';
import { Filter } from '../../models/dynamic-filter.model';
import { EmcSearchOutput } from '../../models/emc-search.model';
import { EMCType } from '../../enums/emc-type';
import { CimClass } from '../../models/network-structure.model';
@Component({
  selector: 'lib-filter-dynamic',
  standalone: false,
  templateUrl: './filter-dynamic.component.html',
  styleUrls: ['./filter-dynamic.component.scss']
})
export class FilterDynamicComponent {
  @Input() substationTemplateId: number = 0;
  @Input() entityType?: EMCType;
  @Input() cimClass?: CimClass;
  EMCType = EMCType;
  @Output() filter = new EventEmitter<Filter>();
  @Output() sortChanged = new EventEmitter<SortType>();
  @Output() filterWindow = new EventEmitter<boolean>();
  @Output() dynamicFilterWindow = new EventEmitter<boolean>();
  @Output() addFilterCard = new EventEmitter<ChecklistItem>(); 
  @Output() clearSearch = new EventEmitter<void>();
  @Output() searchOutputFilter = new EventEmitter<EmcSearchOutput>();

  mapSortBy: Record<number, string> = {
    [SortType.NEWEST]: 'Newest',
    [SortType.ID_ASC]: 'ID',
    [SortType.ID_DESC]: 'ID',
    [SortType.SLRN_ASC]: 'SLRN',
    [SortType.SLRN_DESC]: 'SLRN',
  };

  dropdownOpened: boolean = false;
  sortByValue: SortType = SortType.NEWEST;
  sortByName: string = this.mapSortBy[SortType.NEWEST];
  sortByOptions = SortType;
  searchText: string = '';
  ngOnInit(): void { }

  onSearchChange(text: string) {
    this.searchText = text;
  }

  onAddFilter() {
    this.filterWindow.emit(true);
  }

  onAddDynamicFilter() {
    this.dynamicFilterWindow.emit(true);
  }

  toggleDropdown() {
    this.dropdownOpened = !this.dropdownOpened;
  }

  selectSortByOption(option: SortType) {
    this.sortByValue = option;
    this.sortByName = this.mapSortBy[option];
    this.sortChanged.emit(option);
    this.dropdownOpened = false;
  }
  searchOutput(outputObject: any) {
    this.searchOutputFilter.emit(outputObject);
    if (outputObject.searchValue.trim()) {
      const checklistItem = new ChecklistItem(
        'Search',
        outputObject.searchValue.trim(),
        'COMMON.SEARCH',
        outputObject.searchValue.trim()
      );
      this.addFilterCard.emit(checklistItem);
    }
  }
  addSlrnFilter() {
    if (this.searchText.trim()) {
      const checklistItem = new ChecklistItem(
        'Search',
        this.searchText.trim(),
        'COMMON.SEARCH',
        this.searchText.trim()
      );
      this.addFilterCard.emit(checklistItem);
      this.searchText = '';
    }
  }
}
